import { queryFor } from "@visioni/a3s-client-api/app";
import { listVehiclesEndpoint, listCamerasEndpoint } from "../client-messages/vehicles";

export const vehiclesQuery = queryFor(listVehiclesEndpoint);

export const vtCamerasQuery = queryFor(listCamerasEndpoint);
